import {
  ApartmentOutlined,
  AppstoreAddOutlined,
  BookOutlined,
  HistoryOutlined,
  SettingOutlined,
  TeamOutlined,
} from '@ant-design/icons'
import OrganisationAvatar from 'Components/Avatar/OrganisationAvatar'
import LinkItem from 'Components/LinkItem'
import MenuItem from 'Components/Menu/MenuItem'
import { useCurrentOrganisation } from 'Hooks/useCurrentOrganisation'
import { ComingSoonMenu } from 'Layouts/ApplicationsLayout/styled'
import { HomeRow, MenuTitle } from 'Layouts/styled'
import Authorize from 'Models/Authorize'
import { isSkitUser } from 'Utils/isSkitUser'
import { useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router'
import AuthBaseLayout from '../AuthBaseLayout'
const homeKey = 'voice-agents'

const OrganisationLayout = ({ children, ...props }) => {
  const location = useLocation()
  const { organisation, error } = useCurrentOrganisation()
  const navigate = useNavigate()

  useEffect(() => {
    if (error?.detail === 'IP') navigate('/ip-restricted', { state: { internal_nav: true } })
  }, [error])
  return organisation ? (
    <AuthBaseLayout
      menu={[
        <MenuItem
          key={homeKey}
          to={`/clients/${organisation?.uuid}/${homeKey}`}
          icon={<ApartmentOutlined />}
          selected={location.pathname.includes('voice-agents')}
        >
          Home
        </MenuItem>,
        <MenuItem
          key="templates"
          to={`/clients/${organisation?.uuid}/templates`}
          icon={<AppstoreAddOutlined />}
          style={{
            margin: '0.125rem 0',
          }}
        >
          Template Store
        </MenuItem>,
        <Authorize key="audit-logs" org={organisation?.uuid} reqPermissions={['list_audit_logs']}>
          <MenuItem
            to={`/clients/${organisation?.uuid}/audit-logs`}
            icon={<HistoryOutlined />}
            style={{
              margin: '0.125rem 0',
            }}
          >
            Audit logs
          </MenuItem>
        </Authorize>,
        <LinkItem key="teams" to={`/teams`} icon={<TeamOutlined />} onClick={() => {}} disabled>
          <ComingSoonMenu title="Teams"></ComingSoonMenu>
        </LinkItem>,
        <LinkItem key="learn" to={`/learn`} icon={<BookOutlined />} disabled>
          <ComingSoonMenu title="Learn"></ComingSoonMenu>
        </LinkItem>,
      ]}
      bottomMenu={[
        isSkitUser() === true ? (
          <MenuItem
            style={{
              marginTop: 'auto',
            }}
            key="settings"
            to={`/clients/${organisation?.uuid}/settings/general`}
            icon={<SettingOutlined />}
          >
            Client Settings
          </MenuItem>
        ) : null,
      ]}
      headerRender={({ theme, collapsed }: any) => {
        return (
          <HomeRow theme={theme}>
            <OrganisationAvatar name={organisation?.name} />
            {!collapsed ? <MenuTitle theme={theme}>{organisation.name}</MenuTitle> : null}
          </HomeRow>
        )
      }}
      collapsibleSideNav={false}
    >
      <Outlet />
      {children}
    </AuthBaseLayout>
  ) : null
}

export default OrganisationLayout
